export { default } from './rect';
